/**
 * Auth session helpers — keep React Query cache in sync with login/logout
 * so switching users never reuses the previous account payload / JWT.
 */

export const clearAuthSession = (queryClient) => {
  try {
    localStorage.removeItem("token");
  } catch {
    // ignore
  }
  if (queryClient && typeof queryClient.clear === "function") {
    queryClient.clear();
  }
};

/** After a successful login: wipe cached queries, then store the new JWT. */
export const establishAuthSession = (queryClient, token) => {
  if (queryClient && typeof queryClient.clear === "function") {
    queryClient.clear();
  }
  if (token) {
    localStorage.setItem("token", token);
  }
};
